import store from '@/stores/store'
import { getAppDisplayName } from '@/appDisplayNames'

const CmTaxas = () => import(/* webpackChunkName: "cm-taxas" */ '@/components/cm-taxas.vue')
const Index = () => import(/* webpackChunkName: "cm-taxas" */ '@/components/cm-taxas/Index')
const Consult = () => import(/* webpackChunkName: "cm-taxas" */ '@/components/cm-taxas/Consult')
const Show = () => import(/* webpackChunkName: "cm-taxas" */ '@/components/cm-taxas/Show')
const Setting = () => import(/* webpackChunkName: "cm-taxas" */ '@/components/cm-taxas/Setting')

const getAppName = () => getAppDisplayName('cm-taxas', store.getters.getPartner)

export default {
  children: [
    {
      component: Index,
      meta: {
        breadcrumbs: [{ dynamicName: getAppName }]
      },
      path: '/'
    },
    {
      component: Consult,
      meta: {
        breadcrumbs: [
          { link: '/cm-taxas', dynamicName: getAppName },
          { name: 'Históricos de Consultas' },
        ]
      },
      path: 'consultas'
    },
    {
      component: Setting,
      meta: {
        breadcrumbs: [
          { link: '/cm-taxas', dynamicName: getAppName },
          { name: 'Configurações' },
        ]
      },
      path: 'configuracoes'
    },
    {
      component: Show,
      meta: {
        breadcrumbs: [
          { link: '/cm-taxas', dynamicName: getAppName },
          { dynamicName: () => store.getters.getNameBreadcrumb, name: 'Show' },
        ]
      },
      path: 'taxas/:id',
      props: true
    }
  ],
  component: CmTaxas,
  path: 'cm-taxas'
}
